var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "上传二维码",
        visible: _vm.visible,
        width: 500,
        "mask-closable": false,
        "destroy-on-close": true,
      },
      on: {
        cancel: _vm.handleCancel,
        afterClose: _vm.handleUploadDialogClosed,
      },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "uploadFormRef",
          attrs: {
            model: _vm.uploadForm,
            rules: _vm.uploadRules,
            "label-col": { span: 6 },
            "wrapper-col": { span: 18 },
          },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "型号名称", prop: "deviceModalName" } },
            [
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择型号名称" },
                  model: {
                    value: _vm.uploadForm.deviceModalName,
                    callback: function ($$v) {
                      _vm.$set(_vm.uploadForm, "deviceModalName", $$v)
                    },
                    expression: "uploadForm.deviceModalName",
                  },
                },
                _vm._l(_vm.deviceList, function (device) {
                  return _c(
                    "a-select-option",
                    {
                      key: device.deviceModel,
                      attrs: { value: device.modelName },
                    },
                    [_vm._v(" " + _vm._s(device.modelName) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "二维码文件", prop: "file" } },
            [
              _c(
                "a-upload",
                {
                  ref: "uploader",
                  attrs: {
                    "file-list": _vm.fileList,
                    "before-upload": _vm.beforeUpload,
                    remove: _vm.handleFileRemove,
                    accept: ".zip,.rar",
                  },
                },
                [
                  _c(
                    "a-button",
                    { attrs: { type: "default", icon: "upload" } },
                    [_vm._v("选择压缩包")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "ant-upload-hint",
                  staticStyle: {
                    "font-size": "12px",
                    color: "#8c8c8c",
                    "margin-top": "4px",
                  },
                },
                [_vm._v(" 只能上传 zip/rar 压缩文件，且不超过 50MB ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "dialog-footer" },
          [
            _c("a-button", { on: { click: _vm.handleCancel } }, [
              _vm._v("取消"),
            ]),
            _c(
              "a-button",
              {
                attrs: { type: "primary", loading: _vm.uploading },
                on: {
                  click: function ($event) {
                    return _vm.submitUpload(false)
                  },
                },
              },
              [_vm._v(" 确认 ")]
            ),
            _c(
              "a-button",
              {
                staticStyle: {
                  "background-color": "#52c41a",
                  "border-color": "#52c41a",
                },
                attrs: { type: "primary", loading: _vm.uploading },
                on: {
                  click: function ($event) {
                    return _vm.submitUpload(true)
                  },
                },
              },
              [_vm._v(" 确认并下载 ")]
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }